import { IIdItem, IScheduledItem, ISiteItem } from './resourceParts';

export const ExtractTaskTargetType = {
  Datasource: 'Datasource',
  PublishedConnection: 'PublishedConnection',
  Workbook: 'Workbook'
};

export const ExtractTaskType = {
  ExtractServiceFullRefresh: 'ExtractServiceFullRefresh',
  IncrementExtract: 'IncrementExtract',
  RefreshExtract: 'RefreshExtract'
};

// Extract service task has additional fields apart from extract task.
// Currently it is created for published connection extract task.
export interface IExtractServiceTask extends IIdItem {
  startingItemIds: string[];
  transactionLevel: string;
}

export interface IExtractTask extends IIdItem, IScheduledItem, ISiteItem {
  extractServiceTask?: IExtractServiceTask;
  lastRunAt?: string; // YYYY-MM-DDThh:mm:ssZ
  priority: number;
  runNextAt?: string; // YYYY-MM-DDThh:mm:ssZ
  state: string;
  targetId: string;
  targetType: string; // Datasource or Workbook
  type: string; // RefreshExtract or IncrementExtract
}
